import './css/pagination.css';
export { default as pagination } from './pagination.js';